import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const useEmployerLockUnlockQuery = (employerId: string, isLockMode: boolean) => {
  const { mutateAsync, isLoading, isSuccess } = useMutation(() =>
    isLockMode
      ? api.post(API_URL.ORGANIZATION_LOCKS_LOCK_BY_ORGANIZATION_ID(employerId))
      : api.patch(API_URL.ORGANIZATION_LOCKS_UNLOCK_BY_ORGANIZATION_ID(employerId))
  );

  return {
    mutateAsync,
    isLoading,
    isSuccess,
  };
};
